export const TestIds = {
  core: {
    button: 'tapsi-button',
    input: 'text-input',
    iconButton: 'icon-button',
    tooltipIconButton: 'tooltip-icon-button',
    numericInput: 'numeric-input',
    autocompleteInput: 'autocomplete-input',
    switchInput: 'switch-input',
    selectAutocomplete: 'select-autocomplete',
    selectAutocompleteInput: 'select-autocomplete-input',
    selectAutocompleteOption: 'select-autocomplete-option',
    countDownRefreshBtn: 'count-down-refresh-button',
    gridToolbarBtn: 'grid-toolbar-button',
    menu: 'menu-test-id',
    menuItem: 'menu-item',
    noOptionMenuItem: 'no-option-menu-item',
    selectInput: 'select-input',
    accordionTestId: 'accordion-test-id',
    chart: 'chart',
    checkboxTestId: 'checkbox-test-id',
    formTestId: 'form-test-id',
    linkTestId: 'link-test-id',
    showPasswordIcon: 'show-password-icon',
    dateInput: 'date-input',
    datePicker: 'date-picker',
    dateTime: 'date-time',
    swiper: 'swiper',
    infiniteScroll: 'infinite-scroll',
    inputBase: 'input-base',
    paginationGoTo: 'pagination-go-to',
    pagination: 'pagination',
    radio: 'radio',
    rating: 'rating',
    checkboxInput: 'checkbox-input',
    toast: 'toast',
    treeView: 'tree-view',
  },
  coreComponent: {
    iconButton: 'icon-button',
    autocompleteOption: 'autocomplete-option',
    popover: 'popover',
    popup: 'popup',
    listItem: 'list-item',
    chip: 'chip',
    appDialog: 'app-dialog',
    dialogBackBtn: 'dialog-back-btn',
    step: 'step',
    cardAction: 'card-action',
    tabs: 'tabs',
    accordion: 'accordion',
    accordionSummary: 'accordion-summary',
    dialog: 'dialog',
    calendar: {
      toggleMonth: 'toggle-month',
      toggleYear: 'toggle-year',
      calendarDay: 'calendar-day',
    },
  },
  containerComponent: {
    readOnly: 'read-only',
    clickAwayListener: 'click-away-listener',
    menuContent: 'menu-content',
    listItem: 'list-item',
    map: 'map',
    mapMarker: 'map-marker',
    radioGroup: 'radio-group',
    radioGroupItem: 'radio-group-item',
    video: 'video',
  },
  auth: {
    firstButton: 'first-button',
    secondButton: 'second-button',
    vendor: 'vendor',
  },
  order: {
    exportBtn: 'export-btn',
    exportPdf: 'export-pdf',
    exportPdf8cm: 'export-pdf-8cm',
  },
} as const;
